// extracted by mini-css-extract-plugin
export default {"checkbox":"checkboxesGroupPrice_checkbox__E8-18","item":"checkboxesGroupPrice_item__sLd63","label":"checkboxesGroupPrice_label__SQLKo"};